import React, { useEffect, useState } from 'react';
import { Table, Button, Popconfirm, message, Space, Grid } from 'antd';
import axios from 'axios';
import moment from 'moment';
import TrackWeightModal from '../components/TrackWeightModal';

const { useBreakpoint } = Grid;

const TrackWeightsPage = () => {
  const [weights, setWeights] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
   const screens = useBreakpoint();

  const fetchWeights = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/track-weights`, { withCredentials: true });
      setWeights(res.data);
    } catch (e) {
      message.error('Failed to fetch weights');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchWeights();
  }, []);

  const handleDelete = async (id) => {
    try {
      await axios.delete(`${process.env.REACT_APP_BACKEND_URL}/track-weights/${id}`, { withCredentials: true });
      message.success('Weight entry deleted');
      fetchWeights();
    } catch (e) {
      message.error('Failed to delete weight entry');
    }
  };

  const handleSaveSuccess = () => {
    setModalVisible(false);
    fetchWeights();
  };

  const columns = [
    {
      title: 'Date',
      dataIndex: 'trackDateTime',
      key: 'trackDateTime',
      render: (text) => moment(text).format('YYYY-MM-DD HH:mm'),
      sorter: (a, b) => moment(a.trackDateTime) - moment(b.trackDateTime),
      defaultSortOrder: 'descend',
    },
    {
      title: 'Quantity',
      dataIndex: 'quantity',
      key: 'quantity',
      render: (val) => val.toFixed(2),
    },
    {
      title: 'Unit',
      dataIndex: 'quantityType',
      key: 'quantityType',
      render: (val) => (val === 'imperial' ? 'lbs' : val === 'metric' ? 'kg' : val),
    },
    {
      title: 'Actions',
      key: 'actions',
      render: (_, record) => (
        <Popconfirm
          title="Are you sure to delete this weight entry?"
          onConfirm={() => handleDelete(record.id)}
          okText="Yes"
          cancelText="No"
        >
          <Button danger size="small">
            Delete
          </Button>
        </Popconfirm>
      ),
    },
  ];

  return (
     <div style={{ padding: screens.xs ? 12 : 24 }}>
    <>
<Space style={{ marginBottom: 16, display: 'flex', justifyContent: 'flex-end' }}>
  <TrackWeightModal onSaved={handleSaveSuccess} />
</Space>

<div style={{ overflowX: 'auto', WebkitOverflowScrolling: 'touch' }}>
      <Table
        columns={columns}
        dataSource={weights}
        loading={loading}
        rowKey={(record) => record.id}
        pagination={{ pageSize: 10 }}
      />
</div>
      
    </>
    </div>
  );
};

export default TrackWeightsPage;
